import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsDestinationViewModel} from "../../../../domain/standings/models/destinations/standings.destinations.view-model";
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";

class StandingsWidgetLegendItemProps extends BaseProps {
  row: StandingsDestinationViewModel;
}

export const StandingsWidgetLegendItem = ({row}: StandingsWidgetLegendItemProps) => {
  const bulletProps = {
    className: classNames(styles.legend_item_bullet),
    style: {
      backgroundColor: row.color
    }
  }

  return (
    <div className={classNames(styles.legend_item)}>
      <div {...bulletProps}/>
      {row.name}
    </div>
  );
}
